import React from 'react'
import Link from '../common/util/input/Link'
import cn from 'classnames'

export const TradeNavItem = ({ item }) => {
    return (
        <Link
            href={item.href}
            className="flex font-semibold mx-0 h-full justify-start"
        >
            <li
                key={item.name}
                className={cn(
                    'flex dark:!text-white text-zinc-900 px-3 py-2 items-start w-full rounded-lg transition ease-in-out duration-300',
                    {
                        'hover:bg-gradient-to-br hover:dark:!bg-zinc-800 hover:bg-zinc-300 cursor-pointer':
                            item.href || item.onclick,
                    },
                )}
            >
                <div
                    className={cn(
                        'block dark:!text-white text-zinc-900 font-semibold',
                    )}
                    onClick={item.onclick}
                >
                    {item.name}
                    <p
                        className={cn(
                            'text-[14px] line-clamp-2',
                            { 'text-bold text-primary': item.highlight },
                            { 'text-zinc-500 font-normal': !item.highlight },
                        )}
                    >
                        {item.description}
                    </p>
                </div>
            </li>
        </Link>
    )
}

export default TradeNavItem
